<template>
  <div>
    <canvas id="polar-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: "PolarAreaChart",
  props: ['chartLabel', 'chartData', 'chartMin', 'chartMax'],
  data: function () {
    return {
      planetChartData: {
        type: "polarArea",
        data: {
          labels: this.chartLabel,
          clip: {left: 50, top: 50, right: 50, bottom: 50},
          datasets: [
            { // one line graph
              data: this.chartData,
              backgroundColor: [
                '#8057EF',
                '#6231ea',
                '#a393de',
                '#4b2aaa',
                '#17E5A7',
                '#153e31',
                '#2b765d',
                '#aae8d4',
              ],
              // borderColor: [
              //   '#8057EF',
              // ],
              hoverOffset: 4
            },
          ]
        },
        options: {
          legend: {
            display: true,
            position:'right',
            rtl:true
          },
          responsive: true,
          lineTension: 1,
        }
      }
    }
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = "IRANSans";
    const ctx = document.getElementById('polar-chart');
    new Chart(ctx, this.planetChartData);
  }
}
</script>

